(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/team-results.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/team-results.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.TeamResults = Marionette.CollectionView.extend({
    options: {
      maxNumberOfResults: -1,
      appendEmptyResults: false
    },

    childView: function() {
      return svs.matchen.views.TeamResult;
    },

    emptyView: function() {
      if (
        this.options.appendEmptyResults &&
        this.options.maxNumberOfResults > 0
      ) {
        return _.result(this, 'childView');
      }
    },

    onRenderEmpty: function() {
      if (this.options.appendEmptyResults) {
        this.appendEmptyResults();
      }
    },

    onRenderCollection: function() {
      if (this.options.appendEmptyResults) {
        this.appendEmptyResults();
      }
    },

    appendEmptyResults: function() {
      var model = new svs.matchen.models.Result({ home: '', away: '' });
      var ChildView = _.result(this, 'childView');
      var numberOfEmptyResultsToAdd =
          this.options.maxNumberOfResults - this.children.length;

      _.times(
        numberOfEmptyResultsToAdd,
        function() {
          this.addChildView(new ChildView({ model: model }));
        },
        this
      );
    }
  });
})(Backbone, _, svs);


 })(window);